<template>
    <div class="user-payments">
        <div class="block">
            <InvoiceDetail :uuid="uuid" />
        </div>
    </div>
</template>

<script>
import InvoiceDetail from '../components/Invoice/InvoiceDetail.vue';

export default {
    name: "InvoicePublic",
    props: {
        uuid: { type: String, required: true },
    },
    components: {
        InvoiceDetail
    },
};
</script>
<style scoped>
.user-payments {
    flex: 1;
    padding: 16px;
}

.user-payments h2 {
    color: #555;
}
</style>